
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class MiniEditDialog extends Vue {
  @Prop({ type: String, default: null }) readonly value!: string;
  @Prop({ type: String, default: null }) readonly placeholder!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Boolean, default: true }) readonly editable!: boolean;

  newValue: string | null = null

  created() {
    // console.log(`${this.constructor.name}: created()`); // eslint-disable-line no-console

    this.newValue = this.value;
  }

  @Watch('value')
  onValue(val: string | null) {
    console.log(`${this.constructor.name}: onValue()`); // eslint-disable-line no-console

    this.newValue = val;
  }

  async onSave() {
    console.log(`${this.constructor.name}: onSave()`); // eslint-disable-line no-console

    this.$emit('save', this.newValue);
  }
}
